import React, { useEffect, useMemo, useState } from 'react';
import { FaPlay, FaPause, FaStop } from "react-icons/fa";

import { FaForwardStep,FaCircleCheck  } from "react-icons/fa6";


const TaskTimerAction = ({ task, onStart, onPause, onEnd }) => {
  const [elapsed, setElapsed] = useState("00:00:00");
  const [total, setTotal] = useState("00:00:00");
  

  const sessions = useMemo(() => {
    try {
      const parsed = JSON.parse(task.duration || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [task.duration]);

  const lastSession = sessions[sessions.length - 1];

  useEffect(() => {
    let intervalId;
    let pauseTimerId;

   

    const clampSession = (startInput, endInput) => {
  let durationMs = 0;
  const start = new Date(startInput);
  const end = new Date(endInput);

  const sameDay = start.toDateString() === end.toDateString();

  // If different days, treat end time as 6:00 PM of the start day
  const sessionEnd = sameDay ? end : (() => {
    const e = new Date(start);
    e.setHours(18, 0, 0, 0); // Clamp to 6:00 PM same day
    return e;
  })();

  const workIntervals = [
    { from: { h: 9, m: 30 }, to: { h: 13, m: 30 } },
    { from: { h: 14, m: 0 }, to: { h: 18, m: 0 } },
  ];

  const current = new Date(start);
  const day = current.getDay(); // 0 = Sunday
  if (day === 0) return 0; // skip Sunday

  for (const { from, to } of workIntervals) {
    const intervalStart = new Date(start);
    intervalStart.setHours(from.h, from.m, 0, 0);

    const intervalEnd = new Date(start);
    intervalEnd.setHours(to.h, to.m, 0, 0);

    const actualStart = new Date(Math.max(intervalStart, start));
    const actualEnd = new Date(Math.min(intervalEnd, sessionEnd));

    if (actualStart < actualEnd) {
      durationMs += actualEnd - actualStart;
    }
  }

  return durationMs;
};


    const calculateTotalTime = () => {
      let totalMs = 0;
      sessions.forEach((s) => {
        if (!s.start) return;
        const start = new Date(s.start);
        const end = s.end
          ? new Date(s.end)
          : s.pause
          ? new Date(s.pause)
          : new Date();
        totalMs += clampSession(start, end);
      });
      const h = String(Math.floor(totalMs / 3600000)).padStart(2, "0");
      const m = String(Math.floor((totalMs / 60000) % 60)).padStart(2, "0");
      const s = String(Math.floor((totalMs / 1000) % 60)).padStart(2, "0");
      setTotal(`${h}:${m}:${s}`);
    };

    const calculateElapsed = () => {
      if (!lastSession?.start) return;
      const now = new Date();
      const start = new Date(lastSession.start);
      const end = lastSession.end || lastSession.pause || now;
      const elapsedMs = clampSession(start, end);
      const h = String(Math.floor(elapsedMs / 3600000)).padStart(2, "0");
      const m = String(Math.floor((elapsedMs / 60000) % 60)).padStart(2, "0");
      const s = String(Math.floor((elapsedMs / 1000) % 60)).padStart(2, "0");
      setElapsed(`${h}:${m}:${s}`);
    };

    calculateTotalTime();
    calculateElapsed();

    if (lastSession?.start && !lastSession?.pause && !lastSession?.end) {
      intervalId = setInterval(() => {
        calculateElapsed();
        calculateTotalTime();
      }, 1000);

      const now = new Date();
      const sixPM = new Date();
      sixPM.setHours(17, 59, 0, 0); // today at 5:59 PM

    if (now < sixPM) {
      pauseTimerId = setTimeout(() => {
        if (typeof onPause === 'function') {
          onPause(task);
        }
      }, sixPM - now);
    }
    }

    return () => {
    clearInterval(intervalId);
    clearTimeout(pauseTimerId);
  };
  }, [sessions, lastSession?.start, lastSession?.pause, lastSession?.end,onPause, task]);

  const isRunning = lastSession?.start && !lastSession?.pause && !lastSession?.end;
  const isPaused = lastSession?.pause && !lastSession?.end;
  const isEnded = lastSession?.end;
  const hasAnySessions = sessions.length > 0;

  

  return (
    <div className="flex flex-col items-start gap-1 text-gray-700">
      <div className="flex items-center gap-2">
         {isEnded ? (
        // Show only gray 'Done' box
        <div className="bg-gray-300 text-gray-700 text-xl rounded-full shadow-md font-bold mr-7">
          <FaCircleCheck title='Done'/>
        </div>
      ) : (
        <>
        {(!hasAnySessions || (!isRunning && !isPaused && !isEnded)) && (
          <button
  onClick={(e) => {
    e.stopPropagation();
    if (!task.assign_to || task.assign_to.trim() === "") {
      alert("Please assign this task to someone before starting.");
      return;
    }
    onStart(task);
  }}
  title="Start"
  className='flex bg-green-200 text-[11px] text-green-700 p-1 rounded-full shadow-xl hover:shadow-xl transition px-1 mr-7'
>
  <FaPlay className={isRunning
    ? "text-green-600 border border-green-600 rounded-full p-[3px] text-lg"
    : "text-lg text-green-500 border hover:text-black hover:border-black border-green-500 rounded-full p-[3px]"}
  />
</button>
        )}

        {hasAnySessions && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onPause(task);
              }}
              className={isPaused ? 'flex bg-yellow-200 text-[11px] text-blue-500 p-1 rounded-full shadow-xl hover:shadow-xl transition px-1 mr-7' : 'flex bg-blue-100 text-[11px] text-yellow-600 p-1 rounded-full shadow-xl hover:shadow-xl transition px-1'}
              title={isPaused ?'Resume' : 'Pause'} 
            >
              {isPaused ? <FaForwardStep className={isPaused ? "text-yellow-500 border border-yellow-500 rounded-full p-[3px] text-lg hover:text-black hover:border-black" : "text-lg text-white border border-white rounded-full p-[3px] hover:text-black hover:border-black "} /> : <FaPause className="text-blue-600 border border-blue-600 rounded-full p-[3px] text-lg hover:text-black hover:border-black"  />}
            </button>

            {!isPaused && (
               <button
                  onClick={(e) => {
                    e.stopPropagation();
                
                    if (isPaused) {
                      alert("Please resume the task before ending it.");
                      return;
                    }
                
                    onEnd(task);
                  }}
                  className='flex bg-red-200 text-[11px] text-red-600 p-1 rounded-full shadow-xl hover:shadow-xl transition px-1'
                  title="End"
                >
                  <FaStop className="text-lg text-red-600 border border-red-600 rounded-full p-[3px] hover:text-white hover:border-white" />
                </button>
            )}
          </>
          )}
        </>
        )}
        {isRunning ? (
          <span className="ml-4 text-xs font-mono bg-green-100 text-green-700 border border-green-500 px-1 py-0 rounded-md shadow-sm">
            {total}
          </span>
        ) : (
          <span className={`ml-6 text-xs font-mono text-gray-500 ${ task.status === "Doing" ? "bg-yellow-200 px-1 text-yellow-600 rounded-sm border border-yellow-600" : ""
        }`}>{total}</span>
        )}
        <div className="hidden text-xs text-gray-400 font-mono ml-7">{elapsed}</div>
        
      </div>
    </div>
  );
};

export default TaskTimerAction;
